import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantPreviousEmploymentPage = {
  alert: {
    error: 'applicant-previous-employment-page.form.alert.error',
  },
  footer: {
    root: 'applicant-previous-employment-page.footer.root',
  },
  form: {
    employerNameInput:
      'applicant-previous-employment-page.form.employer-name-input',
    employerNameInputError:
      'applicant-previous-employment-page.form.employer-name-input-error',
    employmentTypeSelect:
      'applicant-previous-employment-page.form.employment-type-select',
    employmentTypeSelectError:
      'applicant-previous-employment-page.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'applicant-previous-employment-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-previous-employment-page.form.gross-annual-income-input-error',
    h1: 'applicant-previous-employment-page.form.h1',
    h2: 'applicant-previous-employment-page.form.h2',
    incomeDisclosure:
      'applicant-previous-employment-page.form.income-disclosure',
    jobTitleInput: 'applicant-previous-employment-page.form.job-title-input',
    jobTitleInputError:
      'applicant-previous-employment-page.form.job-title-input-error',
    root: 'applicant-previous-employment-page.form.root',
    submitButton: 'applicant-previous-employment-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
